import React from 'react';
import { List, useTable, EditButton, ShowButton, DeleteButton } from '@refinedev/antd';
import { Table, Space, Switch, Tag, message } from 'antd';
import { useUpdate } from '@refinedev/core';

interface NotificationReminderDto {
  id: string;
  code: string;
  hour: number;
  minute: number;
  actionType: string;
  title: string;
  body: string;
  isEnabled: boolean;
  sortOrder: number;
}

function formatTime(hour: number, minute: number) {
  return `${String(hour).padStart(2, '0')}:${String(minute).padStart(2, '0')}`;
}

export const NotificationReminderList: React.FC = () => {
  const { tableProps } = useTable<NotificationReminderDto>({
    resource: 'notification-reminders',
    pagination: { current: 1, pageSize: 20 },
  });

  const { mutate: updateReminder } = useUpdate();

  const handleToggle = (record: NotificationReminderDto, checked: boolean) => {
    updateReminder(
      {
        resource: 'notification-reminders',
        id: record.id,
        values: { isEnabled: checked },
      },
      {
        onSuccess: () => {
          message.success(`Reminder ${checked ? 'enabled' : 'disabled'}`);
        },
        onError: () => {
          message.error('Failed to update reminder');
        },
      },
    );
  };

  return (
    <List resource="notification-reminders">
      <Table {...tableProps} rowKey="id">
        <Table.Column
          title="Time"
          render={(_: unknown, record: NotificationReminderDto) =>
            formatTime(record.hour, record.minute)
          }
        />
        <Table.Column dataIndex="code" title="Code" />
        <Table.Column
          dataIndex="actionType"
          title="Action"
          render={(value: string) => <Tag>{value}</Tag>}
        />
        <Table.Column dataIndex="title" title="Title (EN)" ellipsis />
        <Table.Column
          dataIndex="isEnabled"
          title="Enabled"
          render={(isEnabled: boolean, record: NotificationReminderDto) => (
            <Switch
              size="small"
              checked={isEnabled}
              onChange={(checked) => handleToggle(record, checked)}
            />
          )}
        />
        <Table.Column dataIndex="sortOrder" title="Sort" width={80} />
        <Table.Column
          title="Actions"
          dataIndex="actions"
          render={(_: unknown, record: NotificationReminderDto) => (
            <Space>
              <EditButton
                hideText
                size="small"
                recordItemId={record.id}
                resource="notification-reminders"
              />
              <ShowButton
                hideText
                size="small"
                recordItemId={record.id}
                resource="notification-reminders"
              />
              <DeleteButton
                hideText
                size="small"
                recordItemId={record.id}
                resource="notification-reminders"
              />
            </Space>
          )}
        />
      </Table>
    </List>
  );
};
